const config = {
  mode: "production",

  thisHost: "https://developer.ibm.com",
  basePath: "",

  middleware: "https://developer.ibm.com/v1",
  authentication: "https://developer.ibm.com/auth",
  redirect_uri: "https://developer.ibm.com/profile/login",

  iconStore:
    "https://s3.us-east.cloud-object-storage.appdomain.cloud/staging-sombra",

  apis: {
    taxonomies: "/taxonomies",
    home: "/home",
  },

  cache: {
    apiResponseCacheTimeout: 300,
  },

  favIconPath: "/images/favicon.ico",

  ahrefs: {
    siteVerificationToken:
      "9d739b21c466a84dae91df1c79396081a9072152e64f765c9390fed6f249fb84", // This is stage.developer.ibm.com token
  },
   fathom: {
    siteid:
      "SVNCAOGE", 
  },
  segment: {
    key: "a02HT4uQpug4iqNGjlIKyNUaNCshAYKJ",
    productCode: "BDA0002",
    UT30: "30M9V",
  },
  instana: {
    reportingUrl: "https://eum-orange-saas.instana.io",
    key: "a7p2zsCjSESEo7d3uTI-xg",
    allowedHosts: ["developer.ibm.com", "prod-vpcwdc07ibmdeveloper-41208c73af8fca213512856c7a09db52-0000.us-east.containers.appdomain.cloud"],
    serviceName: "frontend-v2",
  },
  features: {
    championsPage: true,
  },
};

config.thisHostAndBasePath = config.thisHost + config.basePath;

module.exports = config;
